import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsDeleteBuildings_buildingIdEnpiSnapshots_snapshotId = z.any()
export type TagsDeleteBuildings_buildingIdEnpiSnapshots_snapshotId = z.infer<typeof tagsDeleteBuildings_buildingIdEnpiSnapshots_snapshotId>

export const paramsDeleteBuildings_buildingIdEnpiSnapshots_snapshotId = z.object({ "buildingId": z.string().uuid(), "snapshotId": z.string().uuid() })
export type ParamsDeleteBuildings_buildingIdEnpiSnapshots_snapshotId = z.infer<typeof paramsDeleteBuildings_buildingIdEnpiSnapshots_snapshotId>

export const responseDeleteBuildings_buildingIdEnpiSnapshots_snapshotId = z.object({ "payload": z.object({ "deleted": z.boolean() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseDeleteBuildings_buildingIdEnpiSnapshots_snapshotId = z.infer<typeof responseDeleteBuildings_buildingIdEnpiSnapshots_snapshotId>

interface IDeleteBuildings_buildingIdEnpiSnapshots_snapshotId extends BaseMethodType {
  tags: TagsDeleteBuildings_buildingIdEnpiSnapshots_snapshotId,
  params: ParamsDeleteBuildings_buildingIdEnpiSnapshots_snapshotId,
  response: ResponseDeleteBuildings_buildingIdEnpiSnapshots_snapshotId
}
export const URL = '/buildings/:buildingId/enpi/snapshots/:snapshotId'
export const validation = {
  delete: {
    tags: tagsDeleteBuildings_buildingIdEnpiSnapshots_snapshotId,
    params: paramsDeleteBuildings_buildingIdEnpiSnapshots_snapshotId,
    response: responseDeleteBuildings_buildingIdEnpiSnapshots_snapshotId
  }
}
export interface Buildings_buildingIdEnpiSnapshots_snapshotId extends BaseRouteType {
  delete: IDeleteBuildings_buildingIdEnpiSnapshots_snapshotId
}